import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGalleries, deleteGallery, changeActiveStatus } from './gallerySlice';
import { Container, Modal, Toast, Button } from "react-bootstrap";
import Input from "../../components/input";
import { useNavigate, useLocation } from "react-router-dom";
import CommonButton from "../../components/commonButton";
import CommonPagination from "../../components/commonPagination";
import CommonTable from '../../components/commonTable';
import { Add01Icon } from "../../assets/icons";
import { useLoader } from "../../context/LoaderContext";
import GalleryAdd from './GalleryAdd';
import GalleryEdit from './GalleryEdit';
import GalleryView from './GalleryView';

const GalleryList = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setLoading } = useLoader();
  const { galleries } = useSelector((state) => state.galleries);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedGalleryId, setSelectedGalleryId] = useState('');
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("success");
  const limit = 10;
  const totalPages = Math.ceil(galleries?.total_records / limit);
  const total = galleries?.total_records || 0;

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialPage = parseInt(params.get("page") || "1");
  const [currentPage, setCurrentPage] = useState(initialPage);
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const selected_organization_id = pathSegments.length > 1 && pathSegments[0] === "organization" 
    ? pathSegments[1] 
    : null;

  const token = localStorage.getItem('admin-auth-token');

  let galleryMessage = localStorage.getItem('gallery_notify_message');

  useEffect(() => {
    if (galleryMessage) {
      setSnackbarMessage(galleryMessage);
      setSnackbarVariant("success");
      setShowSnackbar(true);
      localStorage.removeItem('gallery_notify_message');
    }
  }, [galleryMessage])

  useEffect(() => {
    const fetchGalleries = async () => {
      setLoading(true);
      const payload = {
        organization_id: selected_organization_id,
        page: currentPage,
        search: searchTerm,
        limit: limit,
        token
      };
  
      try {
        if (token && selected_organization_id) {
          await dispatch(getGalleries({ payload }));
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching galleries:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchGalleries();
  }, [dispatch, token, currentPage, searchTerm, setLoading, selected_organization_id]);
  

  const columns = [
    {label: 'Image', key: 'gallery_image', type: 'image' },
    { label: 'Title', key: 'gallery_title' },
    { label: 'created at', key: 'created_at', type: 'date' },
    {label: 'Status', key: 'is_active', type: 'status' },
  ];

  const handlePageChange = (newPageNumber) => {
    setCurrentPage(newPageNumber);
    navigate(`/organization/${selected_organization_id}/galleries?page=${newPageNumber}`);
  };

  const handleDeleteNew = async () => {
    if (selectedGalleryId) {
      await dispatch(deleteGallery(selectedGalleryId)).then((res) => {
        if(res.payload.success) {
          setShowDeleteModal(false);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("success");
          setShowSnackbar(true);
          const payload = {
            organization_id: selected_organization_id,
            page: currentPage,
            search: searchTerm,
            limit: limit,
            token
          };
          dispatch(getGalleries({ payload }));
        } else {
          setShowDeleteModal(false);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("danger");
          setShowSnackbar(true);
        }
      });
    }
  };

  const handleEdit = (row) => {
    // setSelectedGalleryId(row.id);
    navigate(`/organization/${selected_organization_id}/gallery-edit/${row.id}?page=${currentPage}`);
    // handleOpen();
  };

  // const handleOpen = () => {
  //   setTimeout(() => {
  //     setShowEditModal(true);
  //   }, 1000);
  // };
  

  const handleDelete = (row) => {
    setSelectedGalleryId(row.id);
    setShowDeleteModal(true);
  };

  const handleView = (row) => {
    setSelectedGalleryId(row.id);
    setShowViewModal(true);
  };

  const handleStatusChange = async (row) => {
    setSelectedGalleryId(row.id);
    setShowStatusModal(true);
  }

  const handleStatusChangeNew = async () => {
    await dispatch(changeActiveStatus(selectedGalleryId)).then((res) => {
      if(res.payload.success) {
        setShowStatusModal(false);
        setSnackbarMessage(res.payload.message);
        setSnackbarVariant("success");
        setShowSnackbar(true);
        const payload = {
          organization_id: selected_organization_id,
          page: currentPage,
          search: searchTerm,
          limit: limit,
          token
        };
        dispatch(getGalleries({ payload }));
      } else {
        setShowStatusModal(false);
        setSnackbarMessage(res.payload.message);
        setSnackbarVariant("danger");
        setShowSnackbar(true);
      }
    });
  }

  useEffect(() => {
    if (initialPage) {
      setCurrentPage(initialPage);
    }     
  }, [initialPage])

  return (
    <>
      <Container fluid className="px-0">
        <GalleryAdd 
          show={showModal}
          // onHide={() => setShowModal(false)}
          handleClose={() => setShowModal(false)}
          currentPage={currentPage}
          searchTerm={searchTerm}
          limit={limit}
        />
        <GalleryEdit
          galleryId={selectedGalleryId}
          show={showEditModal}
          // onHide={() => setShowEditModal(false)}
          handleClose={() => setShowEditModal(false)}
          currentPage={currentPage}
          searchTerm={searchTerm}
          limit={limit}
        />
        <GalleryView
          show={showViewModal}
          handleClose={() => setShowViewModal(false)}
          galleryId={selectedGalleryId} 
        />

        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete this gallery?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDeleteNew}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showStatusModal} onHide={() => setShowStatusModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Status Update</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to change status?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowStatusModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleStatusChangeNew}>
              Change
            </Button>
          </Modal.Footer>
        </Modal>

        <Toast
          onClose={() => setShowSnackbar(false)}
          show={showSnackbar}
          delay={3000}
          autohide
          bg={snackbarVariant}
          style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
        >
          <Toast.Body style={{ color: "white" }}>{snackbarMessage}</Toast.Body>
        </Toast>

        <div className="p-4 d-flex align-items-center justify-content-between gap-4">
          <Input
            type="search"
            value={searchTerm}
            placeholder="Search Gallery"
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
              navigate(`/organization/${selected_organization_id}/galleries?page=1`);
            }}
            className="shadow-none base-search"
          />

          <CommonButton
            icon={<Add01Icon width={16} height={16} color="#ffffff" strokeWidth="2" />}
            title="Add Gallery"
            className="btn-primary common-one-shadow"
            onClick={() => {
              // setShowModal(true);
              navigate(`/organization/${selected_organization_id}/gallery-add?page=${currentPage}`);
            }}
          />
        </div>

        <div className="bg-white rounded-2 overflow-hidden common-shadow">
            <CommonTable
              columns={columns}
              data={galleries?.data || []}
              url={galleries?.url || []}
              showActions={true}
              actions={{
                showEdit: true,
                showDelete: true,
                showView: false,
                onEdit: handleEdit,
                onDelete: handleDelete,
                onView: handleView
              }}
              onStatusChange={handleStatusChange}
            />
        </div>

        <div className="p-3 mx-1 d-flex flex-wrap align-items-center justify-content-between gap-4">
          <p className="custom-table-infotext">
            Displaying {(limit * (currentPage - 1)) + 1} to {Math.min(limit * currentPage, total)} of {total} galleries
          </p>

          <div>
            {totalPages > 1 ? (
              <CommonPagination
                totalItems={total}
                itemsPerPage={limit}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            ) : null}
          </div>
        </div>
      </Container>
    </>
  );
};

export default GalleryList;
